import { useState, useEffect } from "react";
import { motion } from "framer-motion";

export function ScrollNav({ scrollRef }) {
  const [atTop, setAtTop] = useState(true);
  const [atBottom, setAtBottom] = useState(false);

  useEffect(() => {
    let el = null;
    let rafId = null;
    let checkFn = null;

    const attach = () => {
      el = scrollRef?.current;
      if (!el) { rafId = requestAnimationFrame(attach); return; }
      checkFn = () => {
        setAtTop(el.scrollTop < 40);
        setAtBottom(el.scrollHeight - el.scrollTop - el.clientHeight < 40);
      };
      checkFn();
      el.addEventListener("scroll", checkFn, { passive: true });
    };

    attach();
    return () => {
      if (rafId) cancelAnimationFrame(rafId);
      if (el && checkFn) el.removeEventListener("scroll", checkFn);
    };
  }, [scrollRef]);

  const scrollTo = (dir) => {
    const el = scrollRef?.current;
    if (!el) return;
    el.scrollTo({ top: dir === "top" ? 0 : el.scrollHeight, behavior: "smooth" });
  };

  const btnCls = "w-10 h-10 rounded-full bg-stone-900/95 border border-amber-800/50 text-amber-400 text-lg font-bold flex items-center justify-center shadow-xl active:scale-95 transition-all";

  if (atTop && atBottom) return null;
  return (
    <div style={{ position:"fixed", bottom:"6rem", right:"0.75rem", zIndex:9999, display:"flex", flexDirection:"column", gap:"0.5rem", pointerEvents:"none" }}>
      {!atTop && (
        <motion.button initial={{ opacity:0, x:16 }} animate={{ opacity:1, x:0 }}
          style={{ pointerEvents:"auto" }} className={btnCls} onClick={() => scrollTo("top")}>↑</motion.button>
      )}
      {!atBottom && (
        <motion.button initial={{ opacity:0, x:16 }} animate={{ opacity:1, x:0 }}
          style={{ pointerEvents:"auto" }} className={btnCls} onClick={() => scrollTo("bottom")}>↓</motion.button>
      )}
    </div>
  );
}
